/* eslint-disable no-nested-ternary */

import React, { useContext } from "react";
import {
  Button,
  Icon,
  Grid,
  Header,
  Image,
  Rating,
  Label,
  Checkbox,
} from "semantic-ui-react";
import { useCookies } from "react-cookie";
import { useIntl, Link, FormattedMessage } from "gatsby-plugin-intl";
import Layout from "components/Layout";
import Adsense from "components/Adsense";
import Gallery from "components/Gallery";
import { Block } from "components/StyledComponent";
import HardLink from "components/HardLink";

import { ThemeContext } from "store/theme";

import imageLandingLight from "assets/landing_light.png";
import imageLandingDark from "assets/landing_dark.png";
import imageLandingKrLight from "assets/landing_kr_light.png";
import imageLandingKrDark from "assets/landing_kr_dark.png";

import reviewsImage from "assets/reviews.png";

const FeatureHeader = ({ icon, header, subheader }) => (
  <Grid.Column style={{ padding: "2em" }}>
    <Header as="h2" color="grey">
      <Icon name={icon} color="grey" />
      <Header.Content>
        <FormattedMessage id={header} />
        <Header.Subheader style={{ marginTop: 20, fontSize: "1rem" }}>
          <FormattedMessage id={subheader} />
        </Header.Subheader>
      </Header.Content>
    </Header>
  </Grid.Column>
);

const IndexPage = () => {
  const intl = useIntl();
  const [cookies, setCookie, removeCookie] = useCookies(); // eslint-disable-line
  const { state, dispatch } = useContext(ThemeContext);
  const { darkmode } = state;

  const landingImage = darkmode ? imageLandingDark : imageLandingLight;
  const landingImageKr = darkmode ? imageLandingKrDark : imageLandingKrLight;

  const handleDarkmodeChange = () => {
    if (darkmode) {
      dispatch({ type: "DARKMODE", payload: false });
    } else {
      dispatch({ type: "DARKMODE", payload: true });
    }
  };

  return (
    <Layout landing offer>
      <Block
        color={darkmode ? "darkgrey" : "gray"}
        textAlign="center"
        style={{
          transition: "color 1s ease-out, background-color 0.5s ease-out",
        }}
      >
        <Image
          src={intl.locale === "ko" ? landingImageKr : landingImage}
          style={{
            marginTop: "-15em",
          }}
          centered
        />
        <Label
          color={darkmode ? "orange" : "grey"}
          pointing="below"
          size="small"
          style={{ marginLeft: 20, marginBottom: 15 }}
        >
          {darkmode
            ? intl.formatMessage({ id: "try_darkmode_on" })
            : intl.formatMessage({ id: "try_darkmode" })}
        </Label>
        <div className="darkmode-div">
          <Icon name="moon" color="yellow" />
          <Checkbox toggle checked={darkmode} onClick={handleDarkmodeChange} />
        </div>
      </Block>
      <Block
        inverted={darkmode}
        color={darkmode ? "newblack" : "gray"}
        style={{
          transition: "color 1s ease-out, background-color 0.5s ease-out",
        }}
      >
        <Gallery />
      </Block>
      <Block textAlign="center" visible={!!cookies.picpickupdate}>
        <Adsense type="article" />
      </Block>
      <Block title={intl.formatMessage({ id: "section_features" })}>
        <Grid divided columns="equal" stackable>
          <Grid.Row>
            <FeatureHeader
              icon="camera"
              header="overview_feature_1_h1"
              subheader="overview_feature_1_p1"
            />
            <FeatureHeader
              icon="picture"
              header="overview_feature_2_h1"
              subheader="overview_feature_2_p1"
            />
          </Grid.Row>
          <Grid.Row>
            <FeatureHeader
              icon="magic"
              header="overview_feature_3_h1"
              subheader="overview_feature_3_p1"
            />
            <FeatureHeader
              icon="cloud"
              header="overview_feature_4_h1"
              subheader="overview_feature_4_p1"
            />
          </Grid.Row>
          <Grid.Row>
            <FeatureHeader
              icon="pencil square"
              header="overview_feature_5_h1"
              subheader="overview_feature_5_p1"
            />
            <FeatureHeader
              icon="setting"
              header="overview_feature_6_h1"
              subheader="overview_feature_6_p1"
            />
          </Grid.Row>
          <Grid.Row centered>
            <Button
              size="large"
              as={Link}
              to="/features"
              content={intl.formatMessage({ id: "button_viewdetail" })}
            />
          </Grid.Row>
        </Grid>
      </Block>

      <Block color="gray" title={intl.formatMessage({ id: "section_reviews" })}>
        <Grid stackable verticalAlign="middle" style={{ paddingBottom: "2em" }}>
          <Grid.Column width={10} style={{ paddingBottom: "3em" }}>
            <Header as="h3" size="large" color="orange">
              <FormattedMessage id="reviews_1_author" />{" "}
              <Rating icon="star" rating={5} maxRating={5} disabled />
            </Header>
            <FormattedMessage id="reviews_1_body" />
            <Header as="h3" size="large" color="orange">
              <FormattedMessage id="reviews_2_author" />{" "}
              <Rating icon="star" rating={5} maxRating={5} disabled />
            </Header>
            <FormattedMessage id="reviews_2_body" />
          </Grid.Column>
          <Grid.Column floated="right" width={6}>
            <Image bordered rounded src={reviewsImage} />
          </Grid.Column>
        </Grid>
      </Block>

      <Block textAlign="center" visible={!!cookies.picpickupdate}>
        <Adsense type="article" />
      </Block>

      <Block color="darkblue">
        <Grid stackable verticalAlign="middle">
          <Grid.Column width={10} textAlign="left">
            <Header inverted as="h3" size="large">
              <FormattedMessage id="text_freetotry" />
            </Header>
          </Grid.Column>
          <Grid.Column width={6} textAlign="right">
            <Button
              color="blue"
              size="huge"
              inverted
              as={Link}
              name="download"
              to="/download"
              content={intl.formatMessage({ id: "nav_download" })}
            />
            {intl.locale !== "ko" && (
              <Button
                color="orange"
                size="huge"
                inverted
                as={HardLink}
                name="buy"
                to="/buy"
                content={intl.formatMessage({ id: "nav_buy" })}
              />
            )}
          </Grid.Column>
        </Grid>
      </Block>
    </Layout>
  );
};

export default IndexPage;
